export const GET_CUSTOM_CATEGORIES = 'GET_CUSTOM_CATEGORIES';
export const GET_CUSTOM_CATEGORIES_VALUES = 'GET_CUSTOM_CATEGORIES_VALUES';
export const GET_CUSTOM_CATEGORY = 'GET_CUSTOM_CATEGORY';
